import React, {useEffect, useState} from 'react'
import moment from 'moment-timezone'
import ReactPaginate from 'react-paginate'
import {Button, Spinner} from 'react-bootstrap'
import {MessageReportParams} from '../../../../../services/cellcast.v2.types'
import {useLoadedData} from '../../../../hooks/useGetLoadedData'
import NodataYet from '../../../../Components/NodataYet'
import {
  useAdminGetGlobalSettingQuery,
  useAdminUpdateGlobalSettingMutation,
  useGetAdminMongoScaleQuery,
  usePostAdminMongoScaleMutation,
} from '../../../../../services/cellcast'
import ToggleSwitch from 'react-bootstrap/Form'
import {toast} from 'react-toastify'

const MongoSchedule = () => {
  return (
    <>
      <MongoTrigger />
      <MongoScheduleList />
    </>
  )
}

const MongoTrigger = () => {
  const [triggerMongoScale] = usePostAdminMongoScaleMutation()
  const [updateGlobalSetting] = useAdminUpdateGlobalSettingMutation()

  const [checked, setChecked] = useState(false)
  const {data} = useAdminGetGlobalSettingQuery(null)

  useEffect(() => {
    setChecked(data?.data?.find((it: any) => it?.name === 'MONGO_CONFIG')?.value ? true : false)
  }, [data])

  return (
    <>
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-10'>
          <div className='d-flex flex-column w-100'>
            <h3 className='card-title align-items-start  flex-column'>
              <span className='card-label fw-bolder fs-2 mb-1'>Mongo Scale</span>
            </h3>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-4'>
            <h5
              className='text-gray-600'
              style={{
                fontSize: '18px',
                fontWeight: '600',
              }}
            >
              Mongo Trigger Option
            </h5>
            <div
              className='col-6 mt-2'
              style={{
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
              }}
            >
              <span
                style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  whiteSpace: 'nowrap',
                }}
              >
                Mongo Trigger Global Option
              </span>
              <ToggleSwitch.Check
                onChange={(e) => {
                  setChecked(e.target.checked)

                  updateGlobalSetting({name: 'MONGO_CONFIG', value: e.target.checked})
                    .unwrap()
                    .then((res) => {
                      toast.success(res?.message)
                    })
                    .catch((err) => {
                      toast.error('Failed update status')
                    })
                }}
                checked={checked}
                type='switch'
                id='custom-switch'
                className='col-4'
              />
            </div>
          </div>

          <div className='col-md-8'>
            <h5
              className='text-gray-600'
              style={{
                fontSize: '18px',
                fontWeight: '600',
              }}
            >
              Mongo Manual Scale Trigger
            </h5>

            <div className='gap-2 d-flex'>
              <Button
                name='mongo-trigger'
                title='Mongo Trigger'
                onClick={() => {
                  triggerMongoScale({
                    action: 'SCALE_UP_MONGO',
                  })
                    .unwrap()
                    .then((res) => {
                      toast.success(res?.message)
                    })
                    .catch()
                }}
              >
                Mongo Scale Up Trigger
              </Button>

              <Button
                variant='secondary'
                name='mongo-trigger'
                title='Mongo Trigger'
                onClick={() => {
                  triggerMongoScale({
                    action: 'SCALE_DOWN_MONGO',
                  })
                    .unwrap()
                    .then((res) => {
                      toast.success(res?.message)
                    })
                    .catch()
                }}
              >
                Mongo Scale Down Trigger
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const MongoScheduleList = () => {
  const {calculate, loadedData, setLoadedData} = useLoadedData()
  // configure date range
  const today = new Date() // Current date
  const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)

  const [params, setParams] = useState<MessageReportParams>({
    fromDate: moment(sevenDaysAgo).format('YYYY-MM-DD'),
    toDate: moment(today).format('YYYY-MM-DD'),
    page: 1,
    limit: 10,
  })

  const {data, isLoading, isFetching} = useGetAdminMongoScaleQuery(params)

  useEffect(() => {
    if (data) {
      const loadedData = calculate(
        data && data.data.current ? data.data.current : 1,
        params.limit,
        data && data.data.total ? data.data.total : 0
      )
      setLoadedData(loadedData)
    }
  }, [isLoading, isFetching])

  return (
    <div className='mt-8'>
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-10'>
          <div className='d-flex flex-column w-100'>
            <h3 className='card-title align-items-start  flex-column'>
              <span className='card-label fw-bolder fs-2 mb-1'>Mongo Scale History</span>
              <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
            </h3>
            <div className='d-flex justify-content-end'>
              <div className='col-md-3'></div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data?.items && data?.data?.items?.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5 all-message-table'>
                    <thead>
                      <tr className='fw-400 text-muted'>
                        <th className='p-0 min-w-60px ps-3'>Created At</th>
                        <th className='p-0 min-w-30px ps-3'>Action</th>
                        <th className='p-0 min-w-30px ps-3'>Status</th>
                        <th className='p-0 min-w-30px ps-3'>Instance Size</th>
                        <th className='p-0 min-w-30px ps-3'>Trigger From</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching ? (
                        <tr>
                          <td colSpan={7} className='text-center'>
                            <Spinner />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {data?.data?.items?.map((key, i: any) => {
                            return (
                              <React.Fragment key={i}>
                                <tr className='border-dashed border-2 border-bottom'>
                                  <td className='top-align'>
                                    <span className='text-dark-400 p-0'>{key?.createdAt}</span>
                                  </td>
                                  <td className='top-align'>
                                    <span className='text-dark-400 p-0'>{key?.action}</span>
                                  </td>
                                  <td className='top-align'>
                                    <span className='text-dark-400 p-0'>{key?.status}</span>
                                  </td>

                                  <td className='top-align'>
                                    <span className='text-dark-400 p-0'>{key?.instanceSize}</span>
                                  </td>
                                  <td className='top-align'>
                                    <span className='text-dark-400 p-0'>{key?.triggerFrom}</span>
                                  </td>
                                </tr>
                              </React.Fragment>
                            )
                          })}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className='abcd'>
                  <select
                    onChange={(e: any) => {
                      setParams({...params, limit: e.target.value})
                    }}
                    // value={params.limit || 10}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  {isFetching
                    ? '. . . . .'
                    : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${
                        data.data.total ? data.data.total : 0
                      } data`}
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={data?.data?.totalPages}
                    onPageChange={(e: any) => {
                      setParams({...params, page: e.selected + 1})
                    }}
                    containerClassName={'pagination'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            ) : (
              <NodataYet message='No recent file mongo scale history (yet!)' />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default MongoSchedule
